import React, { useState } from 'react';
import { Tabs } from 'antd';
import LottoActivityTab from './lottoList';
import BlacklistTab from './blacklist';

const { TabPane } = Tabs;

const LottoTabsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('activity');

  return (
    <Tabs
      defaultActiveKey="activity"
      activeKey={activeTab}
      onChange={(key) => setActiveTab(key)}
      destroyInactiveTabPane
    >
      <TabPane tab="活动管理" key="activity">
        <LottoActivityTab active={activeTab === 'activity'} />
      </TabPane>
      <TabPane tab="黑名单管理" key="blacklist">
        <BlacklistTab active={activeTab === 'blacklist'} />
      </TabPane>
    </Tabs>
  );
};

export default LottoTabsPage;
